import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=0a620506"
import script from "./Details.vue?vue&type=script&lang=ts"
export * from "./Details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a620506')) {
      api.createRecord('0a620506', component.options)
    } else {
      api.reload('0a620506', component.options)
    }
    module.hot.accept("./Details.vue?vue&type=template&id=0a620506", function () {
      api.rerender('0a620506', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/requestDetails/Details.vue"
export default component.exports